<template>
	<div class="app-container">
		<el-card class="box-card" shadow="never">
			<div slot="header" class="clearfix">
				<span>审批设置</span>
				<span class="sub">共两级审批，依次由所选管理员处理。</span>
			</div>
			<el-form ref="form" v-loading="loading" :model="form" label-width="140px" style="max-width: 560px;">
				<el-form-item label="第一级审批人" prop="level1_admin_id"
					:rules="[{ required: true, message: '请选择管理员', trigger: 'change' }]">
					<el-select v-model="form.level1_admin_id" filterable clearable placeholder="请选择管理员" style="width: 100%;">
						<el-option v-for="item in adminOptions" :key="item.id" :label="adminLabel(item)" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="第二级审批人" prop="level2_admin_id"
					:rules="[{ required: true, message: '请选择管理员', trigger: 'change' }]">
					<el-select v-model="form.level2_admin_id" filterable clearable placeholder="请选择管理员" style="width: 100%;">
						<el-option v-for="item in adminOptions" :key="item.id" :label="adminLabel(item)" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button v-auth="'UserApprovalSetting.save'" type="primary" :loading="saving" @click="submit">保存</el-button>
				</el-form-item>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import accountApi from '@/api/account'
	import {
		getApprovalSetting,
		saveApprovalSetting
	} from '@/api/user/approvalSetting'

	export default {
		name: 'UserApprovalSetting',
		data() {
			return {
				loading: false,
				saving: false,
				adminOptions: [],
				form: {
					level1_admin_id: null,
					level2_admin_id: null
				}
			}
		},
		created() {
			this.loadAdmins()
			this.loadSetting()
		},
		methods: {
			adminLabel(row) {
				const name = row.realname || row.username || ''
				const phone = row.username || ''
				return name ? `${name}（${phone}）` : String(row.id)
			},
			async loadAdmins() {
				try {
					const {
						data
					} = await accountApi.Query({
						page: 1,
						limit: 500,
						search: ''
					})
					this.adminOptions = (data && data.items) ? data.items : []
				} catch (e) {
					this.adminOptions = []
				}
			},
			async loadSetting() {
				this.loading = true
				try {
					const {
						data
					} = await getApprovalSetting()
					this.form.level1_admin_id = data.level1_admin_id || null
					this.form.level2_admin_id = data.level2_admin_id || null
				} finally {
					this.loading = false
				}
			},
			submit() {
				this.$refs.form.validate(async (valid) => {
					if (!valid) return
					if (this.form.level1_admin_id === this.form.level2_admin_id) {
						this.$message.warning('两级审批不能选择同一管理员')
						return
					}
					this.saving = true
					try {
						await saveApprovalSetting({
							level1_admin_id: this.form.level1_admin_id,
							level2_admin_id: this.form.level2_admin_id
						})
						this.$message.success('保存成功')
					} finally {
						this.saving = false
					}
				})
			}
		}
	}
</script>

<style scoped lang="scss">
	.sub {
		margin-left: 12px;
		font-size: 12px;
		color: #909399;
		font-weight: normal;
	}
</style>